import React from 'react';

const Loader = () => (
  <div className="progress-bar">
  <span className="bar">
    <span className="progress"></span>
  </span>
</div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js